import { z } from "zod"

import { PowurOsEquipmentAssociationTypeEnum } from "../constants"

export const powurOSEquipmentAssociationSchema = z.object({
  parentEquipmentId: z.number().int(),
  parentEquipment: z.nullable(z.any()),
  childEquipmentId: z.number().int(),
  childEquipment: z.nullable(z.any()),
  childRatio: z.number(),
  parentRatio: z.number(),
  associationType: z.number().default(PowurOsEquipmentAssociationTypeEnum.UNIT),
  startDate: z.nullable(z.string()),
  endDate: z.nullable(z.string()),
})
export type PowurOsEquipmentAssociation = z.infer<
  typeof powurOSEquipmentAssociationSchema
>
